export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];
export const IMAGE_TYPES = 'image/jpg,image/jpeg,image/png';
